import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CardDesignerCardElementColorControl from '../../../../../CardDesigner/components/CardDesignerCardElements/CardDesignerCardElementControls/components/CardDesignerCardElementColorControl';
import Label from '../../../../../Label';
import Input from '../../../../../Input';
import ImageUpload from '../../../../../ImageUpload';
import useAssetImageUpload from '../../../../../../../hooks/useAssetImageUpload';
import { IMAGE_SIZE_CODE } from '../../../../../../../constants/image-size-codes';

const propTypes = {
  className: PropTypes.string,
  element: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object.isRequired,
  }).isRequired,
  onElementConfigurationChange: PropTypes.func.isRequired,
};

const CollageDesignerBackgroundControls = ({
  className,
  element = {},
  onElementConfigurationChange,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  const { cardElementConfiguration } = element;
  const [color, setColor] = useState(
    cardElementConfiguration?.background_color,
  );
  const { uploading, onUpload, onUploadReset } = useAssetImageUpload({
    onImageUploaded: async assetImage => {
      onElementConfigurationChange({
        element,
        elementConfig: {
          asset_image_id: assetImage.id,
        },
      });
    },
  });

  return (
    <div className={classes}>
      <div className="card-designer-inline-color-control mb-2">
        <Label id="background-control">Background Color</Label>
        <CardDesignerCardElementColorControl
          defaultColor={cardElementConfiguration?.background_color ?? undefined}
          onChange={hex => {
            setColor(hex);
            onElementConfigurationChange({
              element,
              elementConfig: {
                background_color: hex,
              },
            });
          }}
        />
        <Input id="background-control" value={color} readOnly />
      </div>

      <Label id="background-control">Background Image</Label>
      <ImageUpload
        id="card-designer-background-image"
        buttonText="Upload an image"
        loading={uploading}
        disabled={uploading}
        image={
          cardElementConfiguration?.asset_image
            ? {
                id: cardElementConfiguration.asset_image.id,
                thumbnail_urls: Object.values(IMAGE_SIZE_CODE).map(size => ({
                  size_code: size,
                  url: cardElementConfiguration.asset_image.url,
                  width: 0,
                  height: 0,
                })),
              }
            : null
        }
        onInputChange={event => {
          const [file] = event.target.files;
          onUpload(file);
        }}
        onImageDismiss={() => {
          onUploadReset();
          onElementConfigurationChange({
            element,
            elementConfig: {
              asset_image_id: null,
            },
          });
        }}
      />
    </div>
  );
};

CollageDesignerBackgroundControls.propTypes = propTypes;

export default CollageDesignerBackgroundControls;
